// Toggle the menu open and close when on mobile
// Note: Burger menu has been removed, so this function does nothing now
export default function menuOpen() {
    const burgerButton = document.querySelector('.gh-burger');
    
    // Exit early if burger button doesn't exist (it's been removed)
    if (!burgerButton) return;
    
    burgerButton.addEventListener('click', function () {
        document.body.classList.toggle('gh-head-open');
    });
}